/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { ScanPhoto } from "../../../../gen/scan_planner/scan_photo";
import { ScanWaypoint } from "../../../../gen/scan_planner/scan_waypoint";
import { Uuid } from "../../../../gen/uuid_util/uuid";
import { PlanSettings } from "../../../../util/trajectory_action_planner/trajectory_action_planner";
import { FrameType_Enum, frameType_EnumFromJSON, frameType_EnumToJSON } from "../../waypoints";

export const protobufPackage = "skills";

/** Reason for inspect action to not be completed */
export enum InspectFailureReason {
  NO_FAILURE = 0,
  STUCK = 1,
  PHOTO_FAILURE = 2,
  PROGRESS_TIMEOUT = 3,
  INVALID_INPUT = 4,
  UNRECOGNIZED = -1,
}

export function inspectFailureReasonFromJSON(object: any): InspectFailureReason {
  switch (object) {
    case 0:
    case "NO_FAILURE":
      return InspectFailureReason.NO_FAILURE;
    case 1:
    case "STUCK":
      return InspectFailureReason.STUCK;
    case 2:
    case "PHOTO_FAILURE":
      return InspectFailureReason.PHOTO_FAILURE;
    case 3:
    case "PROGRESS_TIMEOUT":
      return InspectFailureReason.PROGRESS_TIMEOUT;
    case 4:
    case "INVALID_INPUT":
      return InspectFailureReason.INVALID_INPUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InspectFailureReason.UNRECOGNIZED;
  }
}

export function inspectFailureReasonToJSON(object: InspectFailureReason): string {
  switch (object) {
    case InspectFailureReason.NO_FAILURE:
      return "NO_FAILURE";
    case InspectFailureReason.STUCK:
      return "STUCK";
    case InspectFailureReason.PHOTO_FAILURE:
      return "PHOTO_FAILURE";
    case InspectFailureReason.PROGRESS_TIMEOUT:
      return "PROGRESS_TIMEOUT";
    case InspectFailureReason.INVALID_INPUT:
      return "INVALID_INPUT";
    case InspectFailureReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TrajectoryInspectActionArgs {
  /** Waypoints from the scan plan */
  scanWaypoints: ScanWaypoint[];
  trajectoryActionPlanSettings:
    | PlanSettings
    | undefined;
  /** The frame in which scan_waypoints are specified */
  frame: FrameType_Enum;
}

export interface TrajectoryInspectResultData {
  completedWaypointUuids: Uuid[];
  photos: ScanPhoto[];
  failureReason: InspectFailureReason;
  /** Time spent doing the inspection (not counting pauses in the action) */
  inspectionTimeS: number;
}

export interface TrajectoryInspectActionStateData {
  /** index of the last completed waypoint (any type), -1 for no waypoints completed */
  lastCompletedWaypointIdx: number;
  /** estimated time to completion of the trajectory in seconds */
  estimatedTimeToCompletionS: number;
  /** Number of photo waypoints captured so far */
  numPhotoWaypointsCaptured: number;
  /** Number of photo waypoints which have failed or have been skipped */
  numPhotoWaypointsFailedOrSkipped: number;
  /** Number of consecutive photo waypoints where we have been stuck. */
  numConsecutiveStuckPhotoWaypoints: number;
}

function createBaseTrajectoryInspectActionArgs(): TrajectoryInspectActionArgs {
  return { scanWaypoints: [], trajectoryActionPlanSettings: undefined, frame: 0 };
}

export const TrajectoryInspectActionArgs = {
  encode(message: TrajectoryInspectActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.scanWaypoints) {
      ScanWaypoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.trajectoryActionPlanSettings !== undefined) {
      PlanSettings.encode(message.trajectoryActionPlanSettings, writer.uint32(18).fork()).ldelim();
    }
    if (message.frame !== 0) {
      writer.uint32(24).int32(message.frame);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryInspectActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryInspectActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.scanWaypoints.push(ScanWaypoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.trajectoryActionPlanSettings = PlanSettings.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.frame = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrajectoryInspectActionArgs {
    return {
      scanWaypoints: globalThis.Array.isArray(object?.scanWaypoints)
        ? object.scanWaypoints.map((e: any) => ScanWaypoint.fromJSON(e))
        : [],
      trajectoryActionPlanSettings: isSet(object.trajectoryActionPlanSettings)
        ? PlanSettings.fromJSON(object.trajectoryActionPlanSettings)
        : undefined,
      frame: isSet(object.frame) ? frameType_EnumFromJSON(object.frame) : 0,
    };
  },

  toJSON(message: TrajectoryInspectActionArgs): unknown {
    const obj: any = {};
    if (message.scanWaypoints?.length) {
      obj.scanWaypoints = message.scanWaypoints.map((e) => ScanWaypoint.toJSON(e));
    }
    if (message.trajectoryActionPlanSettings !== undefined) {
      obj.trajectoryActionPlanSettings = PlanSettings.toJSON(message.trajectoryActionPlanSettings);
    }
    if (message.frame !== 0) {
      obj.frame = frameType_EnumToJSON(message.frame);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryInspectActionArgs>, I>>(base?: I): TrajectoryInspectActionArgs {
    return TrajectoryInspectActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryInspectActionArgs>, I>>(object: I): TrajectoryInspectActionArgs {
    const message = createBaseTrajectoryInspectActionArgs();
    message.scanWaypoints = object.scanWaypoints?.map((e) => ScanWaypoint.fromPartial(e)) || [];
    message.trajectoryActionPlanSettings =
      (object.trajectoryActionPlanSettings !== undefined && object.trajectoryActionPlanSettings !== null)
        ? PlanSettings.fromPartial(object.trajectoryActionPlanSettings)
        : undefined;
    message.frame = object.frame ?? 0;
    return message;
  },
};

function createBaseTrajectoryInspectResultData(): TrajectoryInspectResultData {
  return { completedWaypointUuids: [], photos: [], failureReason: 0, inspectionTimeS: 0 };
}

export const TrajectoryInspectResultData = {
  encode(message: TrajectoryInspectResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.completedWaypointUuids) {
      Uuid.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.photos) {
      ScanPhoto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.failureReason !== 0) {
      writer.uint32(24).int32(message.failureReason);
    }
    if (message.inspectionTimeS !== 0) {
      writer.uint32(32).int64(message.inspectionTimeS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryInspectResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryInspectResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.completedWaypointUuids.push(Uuid.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.photos.push(ScanPhoto.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.failureReason = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.inspectionTimeS = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrajectoryInspectResultData {
    return {
      completedWaypointUuids: globalThis.Array.isArray(object?.completedWaypointUuids)
        ? object.completedWaypointUuids.map((e: any) => Uuid.fromJSON(e))
        : [],
      photos: globalThis.Array.isArray(object?.photos) ? object.photos.map((e: any) => ScanPhoto.fromJSON(e)) : [],
      failureReason: isSet(object.failureReason) ? inspectFailureReasonFromJSON(object.failureReason) : 0,
      inspectionTimeS: isSet(object.inspectionTimeS) ? globalThis.Number(object.inspectionTimeS) : 0,
    };
  },

  toJSON(message: TrajectoryInspectResultData): unknown {
    const obj: any = {};
    if (message.completedWaypointUuids?.length) {
      obj.completedWaypointUuids = message.completedWaypointUuids.map((e) => Uuid.toJSON(e));
    }
    if (message.photos?.length) {
      obj.photos = message.photos.map((e) => ScanPhoto.toJSON(e));
    }
    if (message.failureReason !== 0) {
      obj.failureReason = inspectFailureReasonToJSON(message.failureReason);
    }
    if (message.inspectionTimeS !== 0) {
      obj.inspectionTimeS = Math.round(message.inspectionTimeS);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryInspectResultData>, I>>(base?: I): TrajectoryInspectResultData {
    return TrajectoryInspectResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryInspectResultData>, I>>(object: I): TrajectoryInspectResultData {
    const message = createBaseTrajectoryInspectResultData();
    message.completedWaypointUuids = object.completedWaypointUuids?.map((e) => Uuid.fromPartial(e)) || [];
    message.photos = object.photos?.map((e) => ScanPhoto.fromPartial(e)) || [];
    message.failureReason = object.failureReason ?? 0;
    message.inspectionTimeS = object.inspectionTimeS ?? 0;
    return message;
  },
};

function createBaseTrajectoryInspectActionStateData(): TrajectoryInspectActionStateData {
  return {
    lastCompletedWaypointIdx: 0,
    estimatedTimeToCompletionS: 0,
    numPhotoWaypointsCaptured: 0,
    numPhotoWaypointsFailedOrSkipped: 0,
    numConsecutiveStuckPhotoWaypoints: 0,
  };
}

export const TrajectoryInspectActionStateData = {
  encode(message: TrajectoryInspectActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lastCompletedWaypointIdx !== 0) {
      writer.uint32(8).int32(message.lastCompletedWaypointIdx);
    }
    if (message.estimatedTimeToCompletionS !== 0) {
      writer.uint32(21).float(message.estimatedTimeToCompletionS);
    }
    if (message.numPhotoWaypointsCaptured !== 0) {
      writer.uint32(24).uint32(message.numPhotoWaypointsCaptured);
    }
    if (message.numPhotoWaypointsFailedOrSkipped !== 0) {
      writer.uint32(32).uint32(message.numPhotoWaypointsFailedOrSkipped);
    }
    if (message.numConsecutiveStuckPhotoWaypoints !== 0) {
      writer.uint32(40).uint32(message.numConsecutiveStuckPhotoWaypoints);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryInspectActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryInspectActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.lastCompletedWaypointIdx = reader.int32();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.estimatedTimeToCompletionS = reader.float();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.numPhotoWaypointsCaptured = reader.uint32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.numPhotoWaypointsFailedOrSkipped = reader.uint32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.numConsecutiveStuckPhotoWaypoints = reader.uint32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrajectoryInspectActionStateData {
    return {
      lastCompletedWaypointIdx: isSet(object.lastCompletedWaypointIdx)
        ? globalThis.Number(object.lastCompletedWaypointIdx)
        : 0,
      estimatedTimeToCompletionS: isSet(object.estimatedTimeToCompletionS)
        ? globalThis.Number(object.estimatedTimeToCompletionS)
        : 0,
      numPhotoWaypointsCaptured: isSet(object.numPhotoWaypointsCaptured)
        ? globalThis.Number(object.numPhotoWaypointsCaptured)
        : 0,
      numPhotoWaypointsFailedOrSkipped: isSet(object.numPhotoWaypointsFailedOrSkipped)
        ? globalThis.Number(object.numPhotoWaypointsFailedOrSkipped)
        : 0,
      numConsecutiveStuckPhotoWaypoints: isSet(object.numConsecutiveStuckPhotoWaypoints)
        ? globalThis.Number(object.numConsecutiveStuckPhotoWaypoints)
        : 0,
    };
  },

  toJSON(message: TrajectoryInspectActionStateData): unknown {
    const obj: any = {};
    if (message.lastCompletedWaypointIdx !== 0) {
      obj.lastCompletedWaypointIdx = Math.round(message.lastCompletedWaypointIdx);
    }
    if (message.estimatedTimeToCompletionS !== 0) {
      obj.estimatedTimeToCompletionS = message.estimatedTimeToCompletionS;
    }
    if (message.numPhotoWaypointsCaptured !== 0) {
      obj.numPhotoWaypointsCaptured = Math.round(message.numPhotoWaypointsCaptured);
    }
    if (message.numPhotoWaypointsFailedOrSkipped !== 0) {
      obj.numPhotoWaypointsFailedOrSkipped = Math.round(message.numPhotoWaypointsFailedOrSkipped);
    }
    if (message.numConsecutiveStuckPhotoWaypoints !== 0) {
      obj.numConsecutiveStuckPhotoWaypoints = Math.round(message.numConsecutiveStuckPhotoWaypoints);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryInspectActionStateData>, I>>(
    base?: I,
  ): TrajectoryInspectActionStateData {
    return TrajectoryInspectActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryInspectActionStateData>, I>>(
    object: I,
  ): TrajectoryInspectActionStateData {
    const message = createBaseTrajectoryInspectActionStateData();
    message.lastCompletedWaypointIdx = object.lastCompletedWaypointIdx ?? 0;
    message.estimatedTimeToCompletionS = object.estimatedTimeToCompletionS ?? 0;
    message.numPhotoWaypointsCaptured = object.numPhotoWaypointsCaptured ?? 0;
    message.numPhotoWaypointsFailedOrSkipped = object.numPhotoWaypointsFailedOrSkipped ?? 0;
    message.numConsecutiveStuckPhotoWaypoints = object.numConsecutiveStuckPhotoWaypoints ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
